import { axios } from '@/utils/request'

const api = {
    getList: '/5dde267336b29',
    exchangeCardByNb: '/5ddddc745cf9c'
}

export default {
    // 获取卡密记录
    getList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 兑换卡密
    exchangeCardByNb: (parameter) => {
        const params = parameter
        return axios({
            url: api.exchangeCardByNb,
            method: 'post',
            data: params
        })
    }
}
